"use strict";

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".video").forEach((section) => {
        const video = section.querySelector("video");
        const muteBtn = section.querySelector(".mute");

        if (!video || !muteBtn) return;
        if (video.muted) {
            muteBtn.classList.remove("on");
        } else {
            muteBtn.classList.add("on");
        }

        muteBtn.addEventListener("click", () => {
            if (video.muted) {
                video.muted = false;
                muteBtn.classList.add("on");
            } else {
                video.muted = true;
                muteBtn.classList.remove("on");
            }
        });
    });
});